<template>
  <base-modal
    :ref="modal.key"
    :title="modal.title"
    :show="open"
    @on-confirm="save"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    :maxWidth="700"
  >
    <v-form class="mt-5">
      <v-text-field
        v-bind:label="$t('Title')"
        v-model="model.widgetTitle"
      ></v-text-field>
      <ColorPicker :label="$t('Color')" v-model="model.color" />

      <ColorPicker :label="$t('TextColor')" v-model="model.textColor" />      
      <v-switch :label="$t('ShowCheckboxes')" v-model="model.checkBoxes" />      
    </v-form>
  </base-modal>
</template>
<script>
import WidgetService from "@/services/WidgetService";
import WidgetSettings from "@/ecm/models/widget/note/WidgetNoteSettings";
import ColorPicker from "@/components/widgets/ColorPicker";
import WidgetType from "@/ecm/variables/WidgetType";

export default {
  components: { ColorPicker },
  data() {
    return {
      id: 0,
      model: new WidgetSettings(),
      modal: {
        title: this.$t("Settings"),
        key: "widgetNoteModal",
      },
      open: false,
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
  },
  methods: {
    async save() {
      this.modalInstance.progress(true);

      var widgetDto = {
        Id: this.id,
        WidgetID: WidgetType.Note,
        Settings: this.model.toDto(),
      };

      WidgetService.updateSettings(widgetDto)
        .then((data) => {
          this.open = false;
          this.$emit("on-save", this.model.toDto());
        })
        .catch((error) => {
          // error
        })
        .then(() => {
          //always
          this.modalInstance.progress(false);
        });
    },
    show(id, dto) {
      this.id = id;
      this.model = new WidgetSettings(dto);
      this.open = true;
    },
    hide() {
      this.open = false;
    },
  },
};
</script>